// extracted by mini-css-extract-plugin
export default {"LeadsHelpful":"t_FmKupVwv4tlAqZES9O","LeadsHelpful__box":"uEeuGWOM_8IPenoDiKGv","LeadsHelpful__BoxItem":"MMEqubuYy6qcOWa4qFbR","LeadsHelpful__Image":"j7QAyMGo4K757K6gLw2s","LeadsHelpful__Textbox":"KlBhKTVtwITKu3T7Olsa","color56A":"IK4PXtlgsPKvNSdAP9Cz","colorEB5":"jBQ9hvy2pYWdOP7BD6KH","RaiseTicketButton":"fU6Rj9jglonFfzXJQSLg","Accordion__Contant__Button":"X_K3vaijF35ayIJXulKo","bluefill_animate":"Dx669EoAai9Pf56uaaTe","Accordion__Contant":"zVYk3CR15Gk478BsEW6O","Accordion__TextContant":"d0r3GIFGAVVKcjiTfwmN"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"LeadsHelpful\":\"t_FmKupVwv4tlAqZES9O\",\"LeadsHelpful__box\":\"uEeuGWOM_8IPenoDiKGv\",\"LeadsHelpful__BoxItem\":\"MMEqubuYy6qcOWa4qFbR\",\"LeadsHelpful__Image\":\"j7QAyMGo4K757K6gLw2s\",\"LeadsHelpful__Textbox\":\"KlBhKTVtwITKu3T7Olsa\",\"color56A\":\"IK4PXtlgsPKvNSdAP9Cz\",\"colorEB5\":\"jBQ9hvy2pYWdOP7BD6KH\",\"RaiseTicketButton\":\"fU6Rj9jglonFfzXJQSLg\",\"Accordion__Contant__Button\":\"X_K3vaijF35ayIJXulKo\",\"bluefill_animate\":\"Dx669EoAai9Pf56uaaTe\",\"Accordion__Contant\":\"zVYk3CR15Gk478BsEW6O\",\"Accordion__TextContant\":\"d0r3GIFGAVVKcjiTfwmN\"}";
        // 1775474908847
        var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  